<template lang="pug">
  div
    Edit(:editDialog="createDialog" @close="close" @updated="updated" :lead="lead")
    v-layout.mt-5(v-if="isLoading" align-center justify-center column fill-height)
      v-progress-circular(size="70" width="7" color="purple" indeterminate)
      div Loading...
    div(v-if="!isLoading")
      v-toolbar.elevation-0(color="info" dark)
        v-toolbar-title
          v-icon.mr-1(medium) filter_list
          span {{ lead.id }}
          span(v-if="lead.businessName")  - {{ lead.businessName }}
          span(v-if="lead.firstName || lead.lastName")  - {{ lead.firstName }} , {{lead.lastName}}
        v-spacer
        v-menu(bottom, left offset-y)
          v-btn(slot='activator', icon)
            v-icon more_vert
          v-list.menu-button
            v-list-tile(@click="edit")
              v-list-tile-title {{ $t('buttons.edit') }}
            v-list-tile(@click="removeLead")
              v-list-tile-title {{ $t('buttons.delete') }}
            v-divider          
            v-list-tile(@click="openActivity")
              v-list-tile-title {{ $t('buttons.activity') }}

      v-card.border-r-0
        v-card-title.pt-0
          v-layout(column)
            v-form
              v-container(fluid)
                v-layout(row wrap align-center justify-start fill-height)
                  v-flex(xs12 sm3)
                    v-autocomplete(v-model="lead.statusID" 
                      :items="comboBoxByID(7).ComboBoxDetails"
                      :label="$t('labels.status')"
                      item-text="selector"
                      item-value="id"
                      @change="updateStatus"
                      attach)
                  v-flex(xs12 sm3)
                    v-autocomplete(v-model="lead.assignedToUserID"
                    @change="updateAssigned"
                    :items="AssignedUser"
                    item-text='fullName'
                    item-value="userID"
                    :label="$t('labels.assignedTo')")
                    //- v-select(v-model="lead.assignedToUserID" 
                    //-   :items="AssignedUser"
                    //-   :label="$t('labels.assignedTo')"
                    //-   item-text="fullName"
                    //-   item-value="userID"
                    //-   attach 
                    //-   chips)
                  
                  v-flex(xs12 sm3)
                    VueCtkDateTimePicker(v-model='leadDueDate' noClearButton overlay label="Follow Up"
                    @validate="setDateTime")
                     

      v-container(fluid grid-list-lg)
        v-layout(row wrap)
          v-flex(xs12 sm4)
            v-layout(column)
              v-flex
                v-card
                  v-toolbar.elevation-0(height="45" color="gray")
                    v-toolbar-title
                      h1.subheading {{ $t('labels.leadDetail') }}              
                  v-card-text
                    v-layout(column)
                      v-layout(row wrap)
                        v-flex {{ $t('labels.phoneNumber') }}
                        v-spacer
                        v-flex.font-weight-regular.text-xs-right {{ lead.phoneNumber | USPhoneNumber }}
                      v-divider
                      v-layout(row wrap)
                        v-flex {{ $t('labels.emailAddress') }}
                        v-spacer
                        v-flex.font-weight-regular.text-xs-right
                          a(@click="sendEmail(lead.email)") {{ lead.email }}
                      v-divider
                      v-layout(row wrap)
                        v-flex {{ $t('labels.location') }}
                        v-spacer
                        v-flex.font-weight-regular.text-xs-right {{ lead.locationCount }}
                      v-divider
                      v-layout(row wrap)
                        v-flex {{ $t('labels.refer') }}
                        v-spacer
                        v-flex.font-weight-regular.text-xs-right {{ lead.refer }}
                      v-divider
                      v-layout(row wrap)
                        v-flex {{ $t('labels.software') }}
                        v-spacer
                        v-flex.font-weight-regular.text-xs-right {{ lead.softwareDetail.selector }}
                      v-divider
                      v-layout(row wrap)
                        v-flex {{ $t('labels.source') }}
                        v-spacer
                        v-flex.font-weight-regular.text-xs-right(v-if="lead.sourceDetail") {{ lead.sourceDetail.selector }}
                        v-flex.font-weight-regular.text-xs-right(v-else) N/A
                      v-divider
                      v-layout(row wrap)
                        v-flex {{ $t('labels.foundUs') }}
                        v-spacer
                        v-flex.font-weight-regular.text-xs-right(v-if="lead.foundUsDetail") {{ lead.foundUsDetail.selector }}
                        v-flex.font-weight-regular.text-xs-right(v-else) N/A
                      v-divider
                      v-layout(row wrap)
                        v-flex {{ $t('labels.createdBy') }}
                        v-spacer
                        v-flex.font-weight-regular.text-xs-right {{ lead.reporterUser.fullName }}
                      
              v-flex
                v-card
                  v-toolbar.elevation-0(height="45" color="gray")
                    v-toolbar-title
                      h1.subheading {{ $t('labels.address') }}            
                  v-card-text
                    v-layout(column)
                      v-layout(row wrap)
                        v-flex {{  $t('labels.streetAddress') }}
                        v-spacer
                        v-flex.font-weight-regular.text-xs-right {{ lead.address }}
                      v-divider
                      v-layout(row wrap)
                        v-flex {{ $t('labels.city') }}
                        v-spacer
                        v-flex.font-weight-regular.text-xs-right {{ lead.city }}
                      v-divider
                      v-layout(row wrap)
                        v-flex {{ $t('labels.state') }}
                        v-spacer
                        v-flex.font-weight-regular.text-xs-right {{ lead.state }}
                      v-divider
                      v-layout(row wrap)
                        v-flex {{ $t('labels.zipCode') }}
                        v-spacer
                        v-flex.font-weight-regular.text-xs-right
                          v-flex.font-weight-regular.text-xs-right {{ lead.zipcode }}
                                        
          v-flex(xs12 sm8)
            v-layout(row wrap)
              v-flex(xs12 v-if="lead.statusID === 30")
                LeadConvert(:lead="lead")
              v-flex(xs12)
                v-card
                  v-toolbar.elevation-0(height="45" color="gray")
                    v-toolbar-title
                      h1.subheading {{ $t('labels.note') }}
                    v-spacer
                    v-btn(small color="info" dark icon @click="updateNote")
                      v-icon(small) save 
                  v-card-text
                    v-textarea(v-model="lead.notes")
              v-flex(xs12)
                CommentList(:refID="lead.id" typeId="4" :ownerID="this.lead.assignedToUserID" @commentCreated="commentCreated")
            Activity(:activityDialog="activityDialog" @close="closeActivity" :refID="lead.id" typeId="4")

</template>

<script>
import leadService from "../service.js";
import CommentList from "../../Comment/components/List";
import Edit from "../components/Edit";
import notificationService from "../../Layout/service.js";
import userService from "../../User/service.js";
import Activity from "../../Comment/components/ActivityDialog";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
const LeadConvert = () => import("../components/LeadConvert");

import { mapGetters, mapActions } from "vuex";

export default {
  name: "lead-view-profile",
  data() {
    return {
      createDialog: false,
      leadDueDate: null,
      dueDatePicker: {
        showTime: false,
        dialog: false,
        date: null,
        initDate: null,
        time: null
      },
      AssignedUser: [],
      selectedAssignedUser: null,
      assignedLoading: false,
      activityDialog: false,
      lead: null,
      isLoading: true,
      location: null
    };
  },
  async created() {
    await this.loadEveryThing();
  },
  components: {
    LeadConvert,
    Edit,
    CommentList,
    VueCtkDateTimePicker,
    Activity
  },
  watch: {
    $route(to, from) {
      if (to && from && to.name === from.name) {
        this.loadEveryThing();
      }
    }
  },
  computed: {
    ...mapGetters("global", ["comboBox", "ComboBox", "comboBoxByID", "currentUser"]),
    dueDateFormatted() {
      let tempDate = null;
      let tempTime = null;
      if (this.dueDatePicker.date) {
        tempDate = this.$moment(this.dueDatePicker.date).format("MM/DD/YYYY");
      }

      if (this.dueDatePicker.time) {
        tempTime = this.dueDatePicker.time;
      } else {
        tempTime = this.$moment(this.dueDatePicker.initDate).format("h:m a");
      }
      return this.$moment(`${tempDate} ${tempTime}`).format("MM/DD/YYYY h:m a");
      // return null
    }
  },
  methods: {
    ...mapActions("global", ["setPageTitle", "sendEmail"]),
    async loadEveryThing() {
      await this.getAllUsers();
      await this.loadLead();
      this.setPageTitle("Lead - " + this.lead.firstName);
      console.log("this.lead in load Everything is :", this.lead);
    },
    removeLead() {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          return leadService
            .delete(this.lead.id)
            .then(response => {
              if (response.data) {
                this.$swal
                  .mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000
                  })
                  .fire({
                    type: "success",
                    title: "Lead has been deleted"
                  });
                // this.$swal('Deleted!', 'Lead has been deleted.', 'success')
                this.$Progress.finish();
                this.$router.push({ path: `/leads/list` });
              }
            })
            .catch(error => {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "error",
                  title: err.data.message
                });
              this.$Progress.fail();
            });
        }
      });
    },
    commentCreated(val) {
      notificationService
        .setNotification({
          heading: "New Comment",
          body: `Comment was left on your lead # ${this.lead.id} by `,
          comment: val,
          forUserID: this.lead.assignedToUserID,
          forUserName: this.selectedAssignedUser.fullName,
          link: `leads/profile/${this.lead.id}`,
          fromID: this.lead.id,
          typeID: 4,
          from: "comment",
          label: "lead",
          emailAddress: this.selectedAssignedUser.loginEmail,
          fromUserID: this.currentUser.userID,
          fromUserName: this.currentUser.fullName
        })
        .then(result => {
          console.log("notification fixed", result);
        });
    },
    updateNote() {
      this.update({
        notes: this.lead.notes
      });
    },
    updateStatus() {
      if (this.lead.statusID === 30) {
        this.$swal({
          title: "Status",
          text:
            "Changing status from convert will remove all converted store from this lead. are you sure you want to do it?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "Yes"
        }).then(result => {
          if (result.value) {
            this.$Progress.start();
            this.update({
              statusID: this.lead.statusID
            });
            this.removeAllConvertedStores();
            this.$Progress.fail();
          } else {
            this.loadLead();
          }
        });
      } else {
        this.removeAllConvertedStores();
        this.update({
          statusID: this.lead.statusID
        });
      }

      this.AssignedUser.map(row => {
        if (row.userID === this.lead.assignedToUserID) this.selectedAssignedUser = row;
      });
      if (this.currentUser.userID !== this.lead.assignedToUserID) {
        notificationService.setNotification({
          heading: "lead",
          body: `lead # ${this.lead.id} status was changed by `,
          forUserID: this.lead.assignedToUserID,
          forUserName: this.selectedAssignedUser.fullName,
          link: `leads/profile/${this.lead.id}`,
          fromID: this.lead.id,
          from: "status",
          label: "lead",
          typeID: 4,
          emailAddress: this.selectedAssignedUser.loginEmail,
          fromUserID: this.currentUser.userID,
          fromUserName: this.currentUser.fullName
        });
      }
    },
    removeAllConvertedStores() {
      return leadService.removeAllConvertedStores(this.lead.id).then(result => {
        console.log(result);
      });
    },
    updateAssigned() {
      this.AssignedUser.map(row => {
        if (row.userID === this.lead.assignedToUserID) this.selectedAssignedUser = row;
      });
      this.update({
        assignedToUserID: this.lead.assignedToUserID
      });
      notificationService.setNotification({
        heading: "Lead",
        body: `Lead # ${this.lead.id} was assigned to you by `,
        forUserID: this.lead.assignedToUserID,
        forUserName: this.selectedAssignedUser.fullName,
        link: `leads/profile/${this.lead.id}`,
        fromID: this.lead.id,
        from: "assigned",
        label: "lead",
        typeID: 4,
        emailAddress: this.selectedAssignedUser.loginEmail,
        fromUserID: this.currentUser.userID,
        fromUserName: this.currentUser.fullName
      });
    },
    update(data) {
      console.log("data is :", data);
      console.log("this.lead", this.lead);
      return leadService
        .update(this.lead.id, data)
        .then(result => {
          if (result.status) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              })
              .fire({
                type: "success",
                title: "Lead was updated"
              });
          }
        })
        .catch(err => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000
            })
            .fire({
              type: "error",
              title: err.data.data
            });
        });
    },
    updated() {
      this.close();
    },
    close() {
      this.createDialog = false;
    },
    edit() {
      this.createDialog = true;
    },
    async setDateTime(val) {
      const { value: text } = await this.$swal.fire({
        title: "Reason",
        input: "textarea",
        inputPlaceholder: "Type your message here...",
        showCancelButton: true
      });
      if (text) {
        let data = {
          dueDate: this.$moment(this.leadDueDate).toISOString(),
          reason: text
        };
        this.update(data);
      } else {
        this.leadDueDate = this.$moment(this.lead.dueDate);
      }
    },
    openStore() {
      this.$router.push({ path: `/location/profile/${this.location.storeID}` });
    },
    openWithIcon() {
      let routeData = this.$router.resolve({ path: `/location/profile/${this.location.storeID}` });
      window.open(routeData.href, "_blank");
    },
    openActivity() {
      this.activityDialog = true;
    },
    closeActivity() {
      this.activityDialog = false;
    },
    getAllUsers() {
      return userService.getAllCrmUser().then(result => {
        this.AssignedUser = result.data;
        this.assignedLoading = false;
      });
    },
    loadLead() {
      if (!this.$route.params || !this.$route.params.id) return this.$router.push("/leads");
      const id = this.$route.params.id;
      this.$Progress.start();
      return leadService.getById(id).then(response => {
        console.log("response lead", response);
        this.$Progress.finish();
        this.lead = response.data;
        this.leadDueDate = this.$moment(response.data.dueDate);
        this.AssignedUser.map(row => {
          if (row.userID === this.lead.assignedToUserID) this.selectedAssignedUser = row;
        });
        this.isLoading = false;
      });

      this.$Progress.finish();
    }
  }
};
</script>

<style scoped></style>
